// extracted by mini-css-extract-plugin
export default {"warningIconActive":"CurrentAlarms_warningIconActive__lPQ0-","warningIcon":"CurrentAlarms_warningIcon__Khpbr"};